import React from "react";
class H1 extends React.Component {
  constructor() {
    super();
    this.state = {
      backgroundColor: '',
      display:''
   };
  }
componentDidMount() {
    const path = this.props.history.location.pathname;
    this.setAttributes(path);
  }
  setAttributes = (path) => {
    let bg,display;
    if (path === '/') {
      bg = 'black'; 
      display = 'none';
    } else {
      bg = 'red';
      display = 'inline-block';
    }
    this.setState({ backgroundColor: bg ,display:display});
  };
 render() {
    const { backgroundColor,display} = this.state;
    return (
      <div>
        <nav className="navbar" style={{ backgroundColor: backgroundColor }}>
          <div className="container-fluid d-flex">
            <a className="navbar-brand" href="/" style={{display:display }}>
              <img src="./Assets/L1.jpeg" alt="="style={{ borderRadius: "50%", height: "80px", width: "80px" }}  />
            </a>
            </div>
        </nav>
      </div>
    );
  }
}

export default H1;
